import Vue from 'vue'
import dateFormatter from '@/helpers/dateFormatter'
import FORMAT from '@/config/format'

Vue.filter('date', function (value) {
  return dateFormatter(value, FORMAT.date)
})

Vue.filter('time', function (value) {
  return dateFormatter(value, FORMAT.time)
})

Vue.filter('dateTime', function (value) {
  return dateFormatter(value, FORMAT.dateTimeShort)
})

Vue.filter('dateTimeFull', function (value) {
  return dateFormatter(value, FORMAT.dateTime)
})

Vue.filter('price', function (value) {
  return value / 100
})